module.exports = __webpack_public_path__ + "static/media/11.26c19482.jpg";